import { IGetState, TBoardId, TListId } from '../../../../../../../../../types/types';
import {
    EPushNotificationSettingsScope,
    EPushNotificationSubscribeCases,
    EPushNotificationSettingsTypes
} from '../../../../../../../../../types/rest/IRestPushNotificationSettings';
import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { pushNotificationSet } from '../../../../../../../../../rest/effects/pushNotificationSettings/pushNotificationSet';
import {
    getPushNotificationMoveToListIds
} from '../../../../../../../../../store/model/selectors/getPushNotificationMoveToListIds';
import {
    getPushNotificationSettingsByBoardId
} from '../../../../../../../../../store/model/selectors/getPushNotificationSettingsByBoardId';

export const onMoveToListToggle = (
    boardId: TBoardId,
    listId: TListId,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState,
    ) => {
        let moveToListIds = getPushNotificationMoveToListIds(getState(), boardId);
        const { scope, subscribeCases, types, listChangeToIds } = getPushNotificationSettingsByBoardId(getState(), boardId);
        if (moveToListIds.includes(listId)) {
            moveToListIds = moveToListIds.filter(item => item !== listId);
        } else {
            moveToListIds = [...moveToListIds, listId];
        }
        dispatch(pushNotificationSet(boardId, scope, subscribeCases, types, moveToListIds, listChangeToIds));
    };
    return action;
};
